export default "__VITE_ASSET__BjpO364P__"